<template>
  <el-form :loading="createLoading" ref="form" class="createAlarmForm" :label-width="'200px'" :inline="false"
    label-position="top" :rules="rules" :model="form">
    <el-row>
      <el-col :span="24">
        <el-form-item :label="$t('alarms.name')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="14">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('alarms.telemetry')" prop="telemetry">
              <el-select v-model="form.telemetry" :placeholder="$t('alarms.select')" @change="changeTelemetry">
                <el-option v-for="item in telemetry.data" :key="item.name" :label="$t(`duck.${item.name}`)" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('alarms.source')" prop="source" v-show="telemetrySourceSelect.length > 1">
              <el-select v-model="form.source" :placeholder="$t('alarms.select')">
                <el-option v-for="item in telemetrySourceSelect" :key="item.key" :label="$t(`duck.${item.label}`)"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="24" v-show="isSignal">
            <el-form-item prop="frequencyRange">
              <el-checkbox v-model="form.calculated">{{
                $t("alarms.frequencyRange")
              }}</el-checkbox>
              <AlaramSignalRangeInput
                v-if="form.calculated"
                v-model="form.properties.frequencyRange"
              ></AlaramSignalRangeInput>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-form-item prop="thresholdDirection">
          <slot name="label">
            {{ $t("alarms.trigger") }}
            <el-tooltip :content="$t('alarms.triggerDirectionInfo')" placement="top">
              <em class="el-icon-info"></em>
            </el-tooltip>
          </slot>
          <br />
          <el-radio-group v-model="form.thresholdDirection" border size="small" @change="changeThresholdDirection(i)">
            <el-radio-button label="1" border>{{
            $t("alarms.topLimit")
            }}</el-radio-button>
            <el-radio-button label="0" border>{{
            $t("alarms.bandWidth")
            }}</el-radio-button>
            <el-radio-button label="-1" border>{{
            $t("alarms.bottomLimit")
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('alarms.threshold')">
          <el-form class="thresholdDirectionreverse" label-position="left">
            <el-form-item :label="$t('dashboard.lastalarmscritical')" class="label-inline" style="
                background-color: rgb(249, 20, 20, 0.7);
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
              " v-show="
                form.thresholdDirection == 1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.critical[1]" :disabled="form.thresholdDirection == -1"
                :precision="4" :step="0.01" :min="form.threshold.hazard[1]" size="mini"></el-input-number>
            </el-form-item>

            <el-form-item class="label-inline" :label="$t('dashboard.lastalarmshazard')"
              style="background-color: rgb(249, 147, 20, 0.7)" v-show="
                form.thresholdDirection == 1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.hazard[1]" :disabled="form.thresholdDirection == -1"
                :precision="4" :step="0.01" :min="form.threshold.attention[1]" :max="form.threshold.critical[1]"
                size="mini"></el-input-number>
            </el-form-item>
            <el-form-item class="label-inline" :label="$t('dashboard.lastalarmsattention')"
              style="background-color: rgb(249, 210, 20, 0.7)" v-show="
                form.thresholdDirection == 1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.attention[1]" :disabled="form.thresholdDirection == -1"
                :precision="4" :step="0.01" :min="
                  form.thresholdDirection == 1
                    ? Number.MIN_SAFE_INTEGER
                    : form.threshold.attention[0]
                " :max="form.threshold.hazard[1]" size="mini"></el-input-number>
            </el-form-item>

            <el-form-item class="label-inline" v-bind:class="{
              topLimitradius: form.thresholdDirection == 1,
              bottomLimitRadius: form.thresholdDirection == -1,
            }" :label="$t('alarms.normal')" style="background-color: rgb(20, 210, 20, 0.7)">
              {{
              ` (${form.thresholdDirection != -1
              ? `${form.threshold.attention[1]} > `
              : ""
              }${$t("alarms.normal")}${form.thresholdDirection != 1
              ? ` > ${form.threshold.attention[0]}`
              : ""
              })`
              }}
            </el-form-item>

            <el-form-item class="label-inline" :label="$t('dashboard.lastalarmsattention')"
              style="background-color: rgb(249, 210, 20, 0.7)" v-show="
                form.thresholdDirection == -1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.attention[0]" :disabled="form.thresholdDirection == 1"
                :precision="4" :step="0.01" :min="form.threshold.hazard[0]" :max="
                  form.thresholdDirection == -1
                    ? Number.MAX_SAFE_INTEGER
                    : form.threshold.attention[1]
                " size="mini"></el-input-number>
            </el-form-item>
            <el-form-item class="label-inline" :label="$t('dashboard.lastalarmshazard')"
              style="background-color: rgb(249, 147, 20, 0.7)" v-show="
                form.thresholdDirection == -1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.hazard[0]" :disabled="form.thresholdDirection == 1"
                :precision="4" :step="0.01" :min="form.threshold.critical[0]" :max="form.threshold.attention[0]"
                size="mini"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('dashboard.lastalarmscritical')" class="label-inline" style="
                background-color: rgb(249, 20, 20, 0.7);
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              " v-show="
                form.thresholdDirection == -1 || form.thresholdDirection == 0
              ">
              <el-input-number v-model="form.threshold.critical[0]" :disabled="form.thresholdDirection == 1"
                :precision="4" :step="0.01" :max="form.threshold.hazard[0]" size="mini"></el-input-number>
            </el-form-item>
          </el-form>
        </el-form-item>
      </el-col>
    </el-row>

    <br />
    <el-row>
      <el-form-item>
        <el-button data-v-step="createAlarm" type="primary" @click="save()">{{
        $t("common.save")
        }}</el-button>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import AlaramSignalRangeInput from "./AlarmSignalRangeInput";
export default {
  name: "CreateAlarm",
  events: ["created", "cancelled"],
  // components: { AlaramSignalRangeInput },
  props: ["pointId"],
  mounted() {
    this.form.telemetry = this.telemetry.data[0].name;

    this.changeTelemetry();
    if (this.alarm) {
      this.from = {
        ...this.form,
        ...this.alarm,
      };
    }
  },
  data() {
    var defaultFrequencyRanges = [300, 600];
    var alarmLevels = [
      {
        label: this.$t("alarms.level1"),
        color: "rgb(249, 210, 20)",
        index: 1,
        value: 1,
      },
      {
        label: this.$t("alarms.level2"),
        color: "rgb(249, 147, 20)",
        index: 2,
        value: 2,
      },
      {
        label: this.$t("alarms.level3"),
        color: "rgb(249, 20, 20)",
        index: 3,
        value: 3,
      },
    ];
    return {
      defaultFrequencyRanges: [500, 1000],
      activeAxis: "",
      options: {
        label: "name",
        children: "children",
        checkbox: false,
      },
      alarmLevels: alarmLevels,
      form: {
        name: "",
        point: "",
        telemetry: "",
        source: "",
        thresholdDirection: 1,
        calculated: false,
        properties: {
          frequencyRange: defaultFrequencyRanges,
        },
        threshold: {
          attention: [-2, 2],
          hazard: [-5, 5],
          critical: [-8, 8],
        },
      },
      rules: {},
    };
  },
  created() {

  },
  watch: {},
  computed: {
    ...mapState("admin", ["telemetry", "telemetrySources"]),
    ...mapState("alarm", ["createLoading"]),

    telemetrySourceSelect() {
      let sources = this.telemetrySources.filter(x => x.telemetry == this.form.telemetry);
      console.log("sources", sources);
      if (sources.length) {
        return sources.map(x => {
          return {
            label: x.code,
            key: x.code,
            value: x.code
          };
        });
      } else {
        return [{
          label: "unknown",
          key: "unknown",
          value: "unknown"
        }];

      }
    }
  },
  methods: {
    changeTelemetry() {
      let source = this.telemetrySources.find(x => x.telemetry == this.form.telemetry);
      this.form.source = source.code;
    },
    changeThresholdDirection() {
      this.form.threshold.attention = [-2, 2];
      this.form.threshold.hazard = [-5, 5];
      this.form.threshold.critical = [-8, 8];
    },
    ...mapActions("account", ["changeTab"]),
    ...mapActions("alarm", ["createAlarm"]),

    save() {
      if (this.form.thresholdDirection == 1) {
        this.form.threshold.attention[0] = null;
        this.form.threshold.hazard[0] = null;
        this.form.threshold.critical[0] = null;
      } else if (this.form.thresholdDirection == -1) {
        this.form.threshold.attention[1] = null;
        this.form.threshold.hazard[1] = null;
        this.form.threshold.critical[1] = null;
      }

      this.createAlarm({ pointId: this.pointId, alarm: this.form })
        .then(() => {
          this.$emit("created");

        })
        .catch((e) => {
          console.log(e);
          return e;
        });
    },
  },
};
</script>
<style>
.thresholdDirectionreverse {
  display: flex;
  flex-direction: column;
}

.topLimitradius {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.bottomLimitRadius {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.label-inline .el-form-item__label {
  width: 100px;
  display: inline-block !important;
  padding: 0;
  margin: 0;
  padding-left: 10px;
  color: white;
  text-shadow: 1px 1px 1px black;
}

.label-inline .el-form-item__content {
  display: inline-block !important;
  margin-left: 10px;
}

#alarmTree {
  height: 200px;
  overflow: auto;
}

.select-level-item {
  line-height: 25px;
  padding: 5px;
  color: white;
}

.select-level .el-select-dropdown__item {
  line-height: 25px;
  color: yellow;
  padding: 0px;
}

.createAlarmForm .el-slider__marks-text {
  font-size: 13px;
}

.el-tabs__content {
  pointer-events: all !important;
}
</style>